import React from "react";
import { Typography } from "@mui/material";

const NotesCell = ({ row, onClickDetail }) => {
  const remainingAdvChart =
    (row.appt_count || 0) - (row.adv_chart_completed || 0);
  const missingDictations = (row.appt_count || 0) - (row.total_dictations || 0);
  const remainingScribing =
    (row.total_dictations || 0) - (row.scribing_completed || 0);
  const remainingCoding =
    (row.total_dictations || 0) - (row.coding_review_completed || 0);

  const handleClick = (type) => {
    onClickDetail?.(type, row);
  };

  // If everything is 0, show nothing
  if (
    remainingAdvChart <= 0 &&
    missingDictations <= 0 &&
    remainingScribing <= 0 &&
    remainingCoding <= 0
  ) {
    return null;
  }

  return (
    <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
      {remainingAdvChart > 0 && (
        <>
          {"Remaining "}
          <Typography
            component="span"
            color="primary"
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => handleClick("adv_chart")}
          >
            {remainingAdvChart}
          </Typography>
          {" Advanced Charting"}
          {"\n"}
        </>
      )}

      {missingDictations > 0 && (
        <>
          {"Missing "}
          <Typography
            component="span"
            color="primary"
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => handleClick("missing_dictations")}
          >
            {missingDictations}
          </Typography>
          {" dictations"}
          {"\n"}
        </>
      )}

      {remainingScribing > 0 && (
        <>
          {"Remaining "}
          <Typography
            component="span"
            color="primary"
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => handleClick("scribing")}
          >
            {remainingScribing}
          </Typography>
          {" Incomplete Scribing"}
          {"\n"}
        </>
      )}

      {remainingCoding > 0 && (
        <>
          {"Remaining "}
          <Typography
            component="span"
            color="primary"
            sx={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => handleClick("coding")}
          >
            {remainingCoding}
          </Typography>
          {" Incomplete Coding Review"}
        </>
      )}
    </Typography>
  );
};

export default NotesCell;
